module.exports = __webpack_public_path__ + "img/dqy.7b1ba7b1.png";